import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedOrderType } from 'contracts/OrderTypes';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_ORDER_TYPES_',
  }
);

export interface ListOrderTypesState {
  data: ListedOrderType[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListOrderTypesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedOrderType[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListOrderTypesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListOrderTypesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListOrderTypesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListOrderTypesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListOrderTypesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listOrderTypes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListOrderTypesTypes = Types;
export const ListOrderTypesActions = Creators;
